import { MenuType } from "redux/types/account";
import {
  BookmarkFilled,
  ShoppingBagFilled,
  ComputerFilled,
  HotelFilled
} from "@bedrock/icons-react";
import React from "react";
import _ from "lodash";
import { getVendorStorage } from '@mpc/common/src/utils/vendorStorage';

export const LANGUAGES_MAP = {
  "zh-CN": '简体中文',
  "en": 'English',
}

const MENU_DIVIDER_KEY = 'beehive-menu-divider';

export const GROUPPED_MENU_KEYS = [];

const getFirstAndLastGrouppedIndex = (menus: MenuType[]) => {
  let firstIndex = -1;
  let lastIndex = -1;

  GROUPPED_MENU_KEYS.forEach((key) => {
    const keyMenuIndex = menus.findIndex((item) => item.key === key);

    if (~keyMenuIndex) {
      lastIndex = keyMenuIndex;

      if (!~firstIndex) {
        firstIndex = keyMenuIndex;
      }
    }
  });

  if (~lastIndex && !menus[lastIndex + 1]) {
    lastIndex = -1;
  }

  return { firstIndex, lastIndex };
};

export const getVersionMenus = (menus: MenuType[], menuVersion: string = 'v2') => {
  const versionMenus = menus?.map?.((item) => item.key);
  const grouppedMenus: MenuType[] = [];

  if (menus.length > 0) {
    menus.forEach((menu: MenuType) => {
      if (!!~GROUPPED_MENU_KEYS.indexOf(menu.key)) {
        if (versionMenus.includes(menu.key)) {
          grouppedMenus.push({
            ...menu,
            group_key: menu.key,
            group_name: menu.name,
          });
        }
      } else {
        if (versionMenus.includes(menu.key)) {
          grouppedMenus.push({ ...menu });
        }
      }
    });
  }

  const { lastIndex } = getFirstAndLastGrouppedIndex(grouppedMenus);

  if (~lastIndex) {
    const insertIndex = lastIndex + 1;

    grouppedMenus.splice(insertIndex, 0, {
      key: MENU_DIVIDER_KEY,
      name: MENU_DIVIDER_KEY,
    });
  }

  return treeDataFormat(grouppedMenus);
};

export const menuConbineConf = {
  outWorkbenchPortal: {
    all: true,
    suffixPath: '/outNormalPurchase/pendingQuotePortal',
  },
  outWorkbench: {
    all: true,
    suffixPath: '/outPendingQuote',
  },
  outBidding: {
    all: true,
    suffixPath: '/outToDoProcess',
  },
  outCompanyManagement: {
    all: true,
    suffixPath: '/outCompanyInfo',
  },
}

export const treeDataFormat = (treeArr: any[], conpire = { key: 'path', name: 'title' }) => {
  const data = _.cloneDeep(treeArr);
  const keys = Object.keys(conpire);
  const formatFunc = (data: any[]) => {
    return data.map((item: any) => {      
      // 字段赋值以满足菜单渲染数据模型要求 如 item.path = item.key
      keys.forEach((key) => {
        const targetKey = conpire[key as keyof typeof conpire];
        item[targetKey] = item?.[key];
      });
      // 菜单icon
      const MenuIcon = IconMap[item.key as keyof typeof IconMap];
      item.icon = MenuIcon ? <MenuIcon className='menu-icon' /> : null;
      // 菜单badge
      // item.badge = parseInt(String(Math.random() * 10000));

      const currMenuConbineConf = menuConbineConf[item.key as keyof typeof menuConbineConf];
      if (currMenuConbineConf?.all) {
        item.children = undefined;
        item.path += currMenuConbineConf?.suffixPath || '';
      }
      if (item?.children) {
        item.children = treeDataFormat(item.children);
      }
      return item;
    })
  }
  return formatFunc(data);
}

export const IconMap = {
  'outWorkbenchPortal': ComputerFilled,
  'outWorkbench': ShoppingBagFilled,
  'outBidding': BookmarkFilled,
  'outCompanyManagement': HotelFilled,
}

// 获取当前供应商
export const getCurSupplier = (suppliersList: any[]) => {
  const { vendorId, tenantCode } = getVendorStorage();
  const curSupplier = suppliersList.find((v: any) => v.vendorId === vendorId) || {};
  let full_name = curSupplier.vendorName;
  
  if (curSupplier.vendorId?.indexOf('NEV') > -1) {
    let tenantInfo = curSupplier.tenants?.find((v: any) => v.tenantCode === tenantCode);
    full_name = `${full_name} (${tenantInfo?.tenantName || tenantInfo?.tenantCode})`;
  }
  return { full_name, vendorName: curSupplier.vendorName }
}